import { ActionType } from "../actions/actionTypes";

type SearchState = {
  loading: boolean;
  search: string;
  results: SearchListItems[];
  error?: string;
};

const INITIAL_STATE = {
  loading: false,
  search: "",
  results: [] as SearchListItems[]
};

export default (state = INITIAL_STATE, action: ActionType): SearchState => {
  switch (action.type) {
    case "SEARCH_REQUEST": {
      return {
        ...state,
        loading: true,
        search: action.payload.search,
        results: INITIAL_STATE.results
      };
    }
    case "SEARCH_FAILURE": {
      return { ...state, error: action.payload.message, loading: false };
    }
    case "SEARCH_SUCCESS": {
      return {
        ...state,
        error: undefined,
        search: INITIAL_STATE.search,
        results: action.payload.results,
        loading: false
      };
    }
    case "CLEAR_SEARCH": {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
};
